import { DateTime } from 'luxon';

export const parseTimestamp = (value?: string | null): DateTime | null => {
  if (!value) return null;

  const dateTime = DateTime.fromISO(value);
  return dateTime.isValid ? dateTime : null;
};

export const formatTime = (value?: string) => {
  if (!value) return null;

  const dateTime = DateTime.fromISO(value);
  if (!dateTime.isValid) return null;

  return dateTime.toFormat('HH:mm:ss');
};

// Mirrors the detection-time column (`DetectionGroupRow.tsx`'s `FormattedDate`) so a synthetic
// group's suppression start/end matches the same rendering as an ordinary group's last-seen time.
export const formatOptionalDateTime = (value: string | null | undefined, locale: string) => {
  const dateTime = parseTimestamp(value);
  if (!dateTime) return '-';

  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(dateTime.toJSDate());
};
